import styled from 'styled-components';

const GeneratePaymentLinkContainer = styled.div`
  margin: 10px 30px;
  min-height: 100vh;
`;
const Title = styled.div`
  font-size: 27px;
  font-weight: 900;
`;
const LabelAndTextField = styled.div`
  padding: 10px 0;
  font-weight: 600;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
const Label = styled.div`
  min-width: 230px;
  font-size: 17px;
  font-weight: 900;
`;
const OfferMessageTitle = styled.div`
  font-size: 17px;
  font-weight: 900;
`;
const OfferMessageDescription = styled.div`
  font-size: 16px;
  font-weight: normal;
  max-width: 150px;
  color: #8c8c8c;
`;
const InputField = styled.div``;
const Input = styled.input`
  width: 276px;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid black;
  border-radius: 5px;
`;
const Select = styled.select`
  padding: 10px 0px;
  padding-right: 90px;
  border-radius: 5px;
  border: 1px solid black;
`;
const VerifyDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 17px;
  font-weight: 900;
`;
const DetailContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 5px 0;
`;
const DetailTitle = styled.div`
  min-width: 230px;
  font-size: 17px;
  font-weight: 500;
`;
const FinalPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const FinalAmount = styled.div`
  display: flex;
  flex-direction: row;
`;
const FinalPrice = styled.div`
  font-size: 17px;
  font-weight: 500;
  margin: 10px;
`;
const OriginalPrice = styled.div`
  font-size: 17px;
  font-weight: 500;
  margin: 10px;
  text-decoration: line-through;
`;
const FinalPricePercentage = styled.div`
  background-color: #fefe70;
  text-align: center;
  width: 134px;
  padding: 10px;
  border-radius: 8px;
  color: black;
  font-size: 17px;
  font-weight: 900;
`;
const Error = styled.div`
  color: red;
  font-size: 12px;
  font-weight: normal;
`;
const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export default {
  GeneratePaymentLinkContainer,
  Title,
  LabelAndTextField,
  Label,
  InputField,
  Input,
  Select,
  VerifyDetailsContainer,
  DetailContainer,
  FinalPrice,
  FinalPriceContainer,
  FinalAmount,
  OriginalPrice,
  FinalPricePercentage,
  DetailTitle,
  OfferMessageTitle,
  OfferMessageDescription,
  Error,
  LoaderContainer
};



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/GenerateEmandateLink/styles.js